import React from "react";
import { Handle, Position } from "@xyflow/react";

const STATUS_STYLES = {
  match:        { border: "border-green-400",  bg: "bg-white",      text: "text-gray-800" },
  missing_step: { border: "border-red-400",    bg: "bg-red-50",     text: "text-red-800" },
  extra_step:   { border: "border-yellow-400", bg: "bg-yellow-50",  text: "text-yellow-800" },
};

const ConformanceActivityNode = ({ data }) => {
  const { border, bg, text } = STATUS_STYLES[data.conformanceStatus] ?? STATUS_STYLES.match;

  return (
    <div
      className={`shadow-md rounded-2xl border-2 flex flex-col items-center justify-center overflow-hidden ${border} ${bg}`}
      style={{ width: "100%", height: "100%", pointerEvents: "none" }}
    >
      <Handle
        type="target"
        position={Position.Top}
        style={{ background: "#555", width: 6, height: 6, top: -3, opacity: 0, pointerEvents: "none" }}
      />
      {data.isStart && (
        <span className="text-[9px] font-bold tracking-widest uppercase text-green-600 leading-none mb-0.5">
          ▼ Start
        </span>
      )}
      <div className={`px-2 w-full font-medium text-sm text-center break-words ${text}`}>
        {data.label}
      </div>
      {data.isEnd && (
        <span className="text-[9px] font-bold tracking-widest uppercase text-red-500 leading-none mt-0.5">
          End ▼
        </span>
      )}
      <Handle
        type="source"
        position={Position.Bottom}
        style={{ background: "#555", width: 6, height: 6, bottom: -3, opacity: 0, pointerEvents: "none" }}
      />
    </div>
  );
};

export default ConformanceActivityNode;
